export default "__VITE_ASSET__BrtVk5Am__"